var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/testimonials", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.testimonial
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createTestimonial.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.author,
                              expression: "rules.author"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Author",
                            placeholder: "Enter Testimonial author",
                            "data-vv-name": "author",
                            "cus-name": "author",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.testimonial.author,
                            callback: function($$v) {
                              _vm.$set(_vm.testimonial, "author", $$v)
                            },
                            expression: "testimonial.author"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.designation,
                              expression: "rules.designation"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Designation",
                            placeholder: "Enter author designation",
                            "data-vv-name": "designation",
                            "cus-name": "designation",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.testimonial.designation,
                            callback: function($$v) {
                              _vm.$set(_vm.testimonial, "designation", $$v)
                            },
                            expression: "testimonial.designation"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.location,
                              expression: "rules.location"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Location",
                            placeholder: "Enter location",
                            "data-vv-name": "location",
                            "cus-name": "location",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.testimonial.location,
                            callback: function($$v) {
                              _vm.$set(_vm.testimonial, "location", $$v)
                            },
                            expression: "testimonial.location"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.status.length
                      ? _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.isActive,
                                  expression: "rules.isActive"
                                }
                              ],
                              attrs: {
                                label: "isActive",
                                "data-vv-name": "isActive",
                                "cus-name": "isActive",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.status,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.testimonial.isActive,
                                callback: function($$v) {
                                  _vm.$set(_vm.testimonial, "isActive", $$v)
                                },
                                expression: "testimonial.isActive"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pages.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.pageName,
                                  expression: "rules.pageName"
                                }
                              ],
                              attrs: {
                                label: "Page",
                                "data-vv-name": "pageName",
                                "cus-name": "pageName",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.pages,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.testimonial.pageName,
                                callback: function($$v) {
                                  _vm.$set(_vm.testimonial, "pageName", $$v)
                                },
                                expression: "testimonial.pageName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.quote,
                              expression: "rules.quote"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Quote",
                            placeholder: "Enter Testimonial Quote",
                            "data-vv-name": "quote",
                            "cus-name": "quote",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.testimonial.quote,
                            callback: function($$v) {
                              _vm.$set(_vm.testimonial, "quote", $$v)
                            },
                            expression: "testimonial.quote"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Create Testimonial\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Create Testimonial")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce6759d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce6759d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Testimonials/CreateTestimonial.vue
// module id = 8KAX
// module chunks = 0